module.exports = __webpack_public_path__ + "img/bannerLabel1Green.eedeca92.png";